const DATA_URI_GIF_PREFIX = "data:image/gif;base64,";

export default DATA_URI_GIF_PREFIX;
